import MedicinesBoxInfo from "./MedicinesBoxInfo";

export default MedicinesBoxInfo;